// extracted by mini-css-extract-plugin
module.exports = {"container":"close-button__container___1daBt","container--light":"close-button__container--light___2fZI- close-button__container___1daBt"};